import { keepPreviousData } from "@tanstack/react-query";

import { getClosingCartons } from "@/api/production-api";
import type { ClosingCartonsResponse } from "@/schemas";
import { useCancellingQuery } from "@/hooks/use-cancelling-query";

export interface UseClosingJobsProps {
	filter: string | null;
	pageNumber: number;
	pageSize: number;
}

export const CLOSING_JOBS_QUERY_KEY = "closing-cartons";

export const useClosingJobs = ({ filter, pageNumber, pageSize }: UseClosingJobsProps) => {
	const queryKey = [CLOSING_JOBS_QUERY_KEY, pageNumber, pageSize, filter];

	const queryFn = () =>
		getClosingCartons({
			identifier: filter,
			pageNumber,
			pageSize,
			closingType: "Active",
		});

	const { data, isLoading, error, refetch } = useCancellingQuery<ClosingCartonsResponse>({
		queryKey,
		queryFn,
		placeholderData: keepPreviousData,
		refetchInterval: 5000,
	});

	return {
		data,
		isLoading,
		error,
		refetch,
	};
};
